import classNames from 'classnames';
import React from 'react';

import { filterDOMProps } from '@react-aria/utils';

import type { FlexProps } from '@react-types/layout';
import type { DOMRef } from '@react-types/shared';

import { useDOMRef } from '../../../utils';

export const Flex = React.forwardRef<HTMLDivElement, FlexProps>((props, ref) => {
  const { children, ...otherProps } = props;
  const domRef = useDOMRef(ref as DOMRef<HTMLDivElement>);

  return (
    <div
      {...filterDOMProps(otherProps)}
      ref={domRef}
      className={classNames('flex', props.UNSAFE_className)}
      style={props.UNSAFE_style}
    >
      {children}
    </div>
  );
});

Flex.displayName = 'Flex';
